import React, { useEffect, useRef, useState } from "react";
import { SendPostRequest } from "../../http";
import { useSelector } from "react-redux";
import Spinner from "../Spinner";
import { Link } from "react-router-dom";

const animationList = ["fadeInLeft", "fadeInRight"];

function FirstFeaturedServices({ setIsdata }) {
  const timelineSectionRef = useRef(null);
  const [featuredService, setFeaturedService] = useState([]);
  const [loading, setLoading] = useState(true);
  const sitedata = useSelector((store) => store.global.loginData);

  useEffect(() => {
    getFeaturedService();
  }, []);

  const getFeaturedService = async () => {
    try {
      setLoading(true);
      const response = await SendPostRequest("services/featured_services");
      if (response?.data?.length < 5 && sitedata?.site_type === "hospitals") {
        setIsdata(true);
      }
      setFeaturedService(response?.data || []);
    } catch (error) {
      console.error("Error fetching featured services:", error);
      setFeaturedService([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const handleIntersection = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const animatedItems = entry.target.querySelectorAll("li.animated");
          animatedItems.forEach((item, index) => {
            setTimeout(() => {
              const animationType = item.getAttribute("data-animation");
              if (
                animationType === "fadeInLeft" &&
                !item.classList.contains("visible")
              ) {
                item.classList.add("fadeInLeft", "visible");
              } else if (
                animationType === "fadeInRight" &&
                !item.classList.contains("visible")
              ) {
                item.classList.add("fadeInRight", "visible");
              }
            }, index * 300);
          });
        }
      });
    };

    const observer = new IntersectionObserver(handleIntersection, {
      threshold: 0.1,
    });

    if (timelineSectionRef.current) {
      observer.observe(timelineSectionRef.current);
    }

    return () => {
      if (timelineSectionRef.current) {
        observer.unobserve(timelineSectionRef.current);
      }
    };
  }, [featuredService]);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "300px" }}>
        <Spinner />
      </div>
    );
  }

  if (!featuredService?.length) return null;

  return (
    <section
      id="timeline-section"
      className="timeline-section pad-bottom-20"
      ref={timelineSectionRef}
    >
      <div className="container">
        <div className="row">
          <div className="offset-md-2 col-md-8">
            <div className="title-wrap text-center">
              <div className="section-title margin-bottom-60">
                <h2 className="section-title margin-top-5 mb-0 text-uppercase">
                {sitedata?.site_type === "hospitals" ? "Our Specialties" : "Services"}
                </h2>
                <span className="section-border-bottom center"></span>
              </div>
            </div>
          </div>
          <div className="col-lg-12">
            <div className="timeline-wrapper">
              <ul className="timeline">
                {featuredService?.slice(0, 6)?.map((service, index) => (
                  <li
                    key={index}
                    className={`mb-5 animated ${
                      index % 2 === 1 ? "timeline-inverted" : ""
                    }`}
                    data-animation={animationList[index % 2]}
                    style={{ minHeight: "200px" }} // Added minimum height
                  >
                    <div className="timeline-image">
                      <div
                        className="img-circle first-fservices-img-wrapper"
                        style={{
                          backgroundImage: `url(${service?.service_image_url})`,
                          height: "180px",
                          width: "180px",
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                          position: "absolute" // Added positioning
                        }}
                      />
                    </div>
                    <div 
                      className="timeline-panel" 
                      // style={{
                      //   marginLeft: index % 2 === 0 ? "220px" : "0",
                      //   marginRight: index % 2 === 1 ? "220px" : "0"
                      // }}
                    >
                      <Link
                           to={`/${sitedata?.site_type === "hospitals" ? "speciality" : "service"}/${service?.uid}/${service?.service_title
                          ?.replaceAll(" ", "-")
                          ?.replaceAll("/", "-")}`}
                      >
                        <div className="timeline-heading">
                          <h4 className="timeline-title text-uppercase first-fservices-title">
                            {service?.service_title}
                          </h4>
                        </div>
                        <div
                          className="timeline-body text-black"
                          dangerouslySetInnerHTML={{
                            __html: service?.service_description?.slice(0, 190) + 
                              (service?.service_description?.length > 190 ? "..." : ""),
                          }}
                        />
                      </Link>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default FirstFeaturedServices;